<template>
  <div class="checkout-product-summary card">
    <div class="card-header font-weight-bold">Resumo do pedido</div>
    <div class="card-body" v-if="product && product.id">
      <img class="mb-4" :src="product.cover" />
      <h6>{{ product.title }}</h6>
    </div>
    <div class="card-footer d-flex align-items-center justify-content-between">
      <strong>Total</strong>
      <strong>R$ {{ finalPrice }}</strong>
    </div>
  </div>
</template>

<script>
import { formatMoney } from "@/functions/helpers.js";

export default {
  props: {
    product: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    finalPrice() {
      return formatMoney(
        parseFloat(this.product.price_card) -
          parseFloat(this.product.discount || 0)
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.checkout-product-summary {
  overflow: hidden;

  .card-header,
  .card-footer {
    background: #e5e5e5;
  }

  img {
    width: 96px;
    height: 96px;
    object-fit: cover;
  }

  h6 {
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    color: #272d32;
  }
}
</style>
